//
//
//
//
//
//

export default {
  name: 'App',
};
